export default __webpack_public_path__ + "static/headerBackgroundMobile-9836673ec37d5dc9c815c45fab79185d.png";